import { c as _c } from "react/compiler-runtime";
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import RatingAndReviews from 'components/consumer/RatingAndReviews';
import BVRatingSummary from 'components/consumer/PDP/BazaarVoice/BVRatingSummary';
import { useBazaarVoiceEnabled } from 'hooks/useBazaarVoice';
import ModularPDPRatingAndReviews from './ModularPDPRatingAndReviews';
import usePDPBasicDetails from '../state/context/usePDPBasicDetails';
const CUSTOMER_PHOTOS_ID = '#PDPCustomerPhotos';
const PDPRatingsSection = t0 => {
  const $ = _c(11);
  const {
    numberOfReviews,
    pdpIsModularBYOProduct,
    rating,
    reviewsLoading
  } = t0;
  const history = useHistory();
  const basicDetails = usePDPBasicDetails();
  const baseSku = basicDetails?.data?.sku || null;
  const isBVEnabled = useBazaarVoiceEnabled();
  let t1;
  if ($[0] !== history) {
    t1 = event => {
      event.preventDefault();
      history.push("customer-reviews");
    };
    $[0] = history;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onRatingsAndReviewClick = t1;
  if (isBVEnabled) {
    let t2;
    if ($[2] !== baseSku) {
      t2 = <BVRatingSummary productId={baseSku} />;
      $[2] = baseSku;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (pdpIsModularBYOProduct) {
    let t2;
    if ($[4] !== onRatingsAndReviewClick) {
      t2 = <ModularPDPRatingAndReviews onClick={onRatingsAndReviewClick} href={CUSTOMER_PHOTOS_ID} />;
      $[4] = onRatingsAndReviewClick;
      $[5] = t2;
    } else {
      t2 = $[5];
    }
    return t2;
  }
  let t2;
  if ($[6] !== numberOfReviews || $[7] !== onRatingsAndReviewClick || $[8] !== rating || $[9] !== reviewsLoading) {
    t2 = <RatingAndReviews loading={reviewsLoading} rating={rating} numberOfReviews={numberOfReviews} onClick={onRatingsAndReviewClick} href={CUSTOMER_PHOTOS_ID} />;
    $[6] = numberOfReviews;
    $[7] = onRatingsAndReviewClick;
    $[8] = rating;
    $[9] = reviewsLoading;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  return t2;
};
PDPRatingsSection.propTypes = {
  numberOfReviews: PropTypes.number,
  pdpIsModularBYOProduct: PropTypes.bool,
  rating: PropTypes.number,
  reviewsLoading: PropTypes.bool
};
export default PDPRatingsSection;